module.exports = __webpack_public_path__ + "img/logo-white.e4d923bc.svg";